import { Route } from "@soft-db/typed-router";

const docRoutes = new Route({
	path: "api-docs",
	meta: {
		features: "doc",
		permission: "private-api.get",
	},
	component: () => import("@/pages/api-docs.vue"),
});

export default docRoutes;
